module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canViewComments && _vm.canEditOfficerComments) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_OFFICER)) ? _c('div', [(_vm.field_data.officer_comment) ? _c('a', {
    attrs: {
      "href": "",
      "title": "Officer Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Officer Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : _vm._e(), _vm._v(" "), (_vm.canViewComments && !_vm.canEditOfficerComments && _vm.field_data.officer_comment) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.officer_comment))])]) : _vm._e(), _vm._v(" "), (_vm.canViewDeficiencies && _vm.canEditDeficiencies) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_DEFICIENCY)) ? _c('div', [(_vm.field_data.deficiency_value) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Deficiencies"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Deficiencies"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : _vm._e(), _vm._v(" "), (_vm.canViewDeficiencies && !_vm.canEditDeficiencies && _vm.field_data.deficiency_value) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.deficiency_value))])]) : _vm._e(), _vm._v(" "), (_vm.canViewComments && _vm.canEditAssessorComments) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_ASSESSOR)) ? _c('div', [(_vm.field_data.assessor_comment) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Assessor Comments"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Assessor Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : (_vm.canViewComments && _vm.field_data.assessor_comment) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.assessor_comment))])]) : _vm._e(), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_OFFICER)),
      expression: "showingComment(COMMENT_TYPE_OFFICER)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-officer-comment-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_OFFICER
    }
  }), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_ASSESSOR)),
      expression: "showingComment(COMMENT_TYPE_ASSESSOR)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-assessor-comment-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_ASSESSOR
    }
  }), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_DEFICIENCY)),
      expression: "showingComment(COMMENT_TYPE_DEFICIENCY)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-deficiency-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_DEFICIENCY
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f18b25a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/comment_block.vue
// module id = 1063
// module chunks = 0